export default "__VITE_ASSET__CZVvQC9F__"